'use client';
import React, { useState, useEffect } from 'react';

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (dismissed) return;
      // Show after scrolling ~2 viewport heights
      setVisible(window.scrollY > window.innerHeight * 1.8);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [dismissed]);

  if (dismissed) return null;

  return (
    <div
      className={`sticky-cta fixed bottom-0 left-0 right-0 z-40 ${visible ? 'visible' : ''}`}
    >
      <div
        className="flex items-center justify-between gap-4 px-6 py-4"
        style={{
          background: 'rgba(59,72,86,0.96)',
          backdropFilter: 'blur(16px)',
          borderTop: '1px solid rgba(137,176,208,0.2)',
        }}
      >
        <div className="flex items-center gap-3 min-w-0">
          <div
            className="pulse-dot w-2 h-2 rounded-full flex-shrink-0"
            style={{ background: '#C45B6A' }}
          />
          <p className="text-sm font-medium truncate" style={{ color: 'rgba(244,247,250,0.85)' }}>
            <span className="hidden sm:inline">Ready to go deeper? </span>
            Download the complete hematology workup guide.
          </p>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <a
            href="#resources"
            className="btn-rose px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap"
          >
            Download Guide
          </a>
          <button
            onClick={() => setDismissed(true)}
            aria-label="Dismiss"
            className="w-8 h-8 rounded-full flex items-center justify-center transition-colors"
            style={{ color: 'rgba(244,247,250,0.4)' }}
            onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.color = '#F4F7FA')}
            onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.color = 'rgba(244,247,250,0.4)')}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}